import React, { memo } from 'react'
import QuestionCircle from 'components/CommonUI/svgIcons/QuestionCircle'
import Tooltip from '@material-ui/core/Tooltip'

const Title = ({
  title = '',
  component = 'h1',
  className = '',
  withTooltip,
  tooltipText = '',
  subTitle = '',
  classNameSubTitle = '',
  children = null,
}) => {
  const Component = component
  return (
    <Component className={`custom_title ${className}`}>
      {children ?? title}
      {!!subTitle && <span className={classNameSubTitle}> {subTitle}</span>}
      {withTooltip && (
        <Tooltip
          // title={tooltipText}
          title={<span style={{ fontSize: '13px' }}>{tooltipText}</span>}
          arrow
          placement="top"
          className="tooltip_container"
        >
          <Icon />
        </Tooltip>
      )}
    </Component>
  )
}

const Icon = React.forwardRef(function MyComponent(props, ref) {
  return (
    <span {...props} ref={ref} className="custom_title_icon">
      <QuestionCircle className="tooltip_icon" />
    </span>
  )
})

export default memo(Title)
